module.exports = __webpack_public_path__ + "media/images/page/pause_ic-2315d34ddce9ef8b3ae594752d1b4dc5.svg";